import { FilterOutlined } from "@ant-design/icons";
import { Button, Drawer, Input, Space, Tooltip } from "antd";
import { useState } from "react";
import useDeliveryStore from "../../store/DeliveryStore";
import { chipStyle, sectionLabelStyle, toggle } from "../../helpers/FilterUI";

const BOOKED_BY_OPTIONS = [
  "Nikhil",
  "Yashi",
  "Ashish",
  "Anushree",
  "Akash",
  "Sarthak",
  "Harriet",
  "Aditi",
  "Arunima",
  "Priyanka",
];
const PARTNER_OPTIONS = ["ShipRocket", "ProRouting", "Pidge", "Manual"];

export function RecordsFilters() {
  const { setDrawerFilters, bookedByFilter, outletNameFilter, partnerFilter } =
    useDeliveryStore();
  const [open, setOpen] = useState(false);
  const [bookedBy, setBookedBy] = useState(bookedByFilter);
  const [outletName, setOutletName] = useState(outletNameFilter);
  const [partner, setPartner] = useState(partnerFilter);

  function hasAppliedFilter() {
    return bookedBy.length > 0 || outletName || partner.length > 0;
  }

  function handleReset() {
    setBookedBy([]);
    setOutletName("");
    setPartner([]);
    setDrawerFilters({ bookedBy: [], outletName: "", partner: [] });
  }

  function applyFilters() {
    setDrawerFilters({ bookedBy, outletName, partner });
    setOpen(false);
  }

  return (
    <>
      <Tooltip title="Filter">
        <Button
          type="primary"
          shape="circle"
          icon={<FilterOutlined />}
          onClick={() => setOpen(true)}
          style={{
            borderRadius: 8,
            borderColor: hasAppliedFilter() ? "#BFDBFE" : "#E2E8F0",
            background: hasAppliedFilter() ? "#EFF6FF" : "#fff",
            color: hasAppliedFilter() ? "#1D4ED8" : "#64748B",
            boxShadow: "none",
            fontWeight: hasAppliedFilter() ? 500 : 400,
          }}
        />
      </Tooltip>
      <Drawer
        title="Filters"
        onClose={() => setOpen(false)}
        visible={open}
        extra={
          <Space>
            <Button type="text" onClick={handleReset}>
              Reset
            </Button>
            <Button type="primary" onClick={() => applyFilters()}>
              Apply Filters
            </Button>
          </Space>
        }
      >
        <div style={{ marginBottom: 24 }}>
          <span style={sectionLabelStyle}>Booked By</span>
          <Space wrap size={8}>
            {BOOKED_BY_OPTIONS.map((name) => (
              <Button
                key={name}
                size="small"
                style={chipStyle(bookedBy.includes(name))}
                onClick={() => setBookedBy((prev) => toggle(prev, name))}
              >
                {name}
              </Button>
            ))}
          </Space>
        </div>

        <div style={{ marginBottom: 24 }}>
          <span style={sectionLabelStyle}>Outlet Name</span>
          <Input
            placeholder="Search outlet"
            value={outletName}
            onChange={(e) => setOutletName(e.target.value)}
            style={{ borderRadius: 8 }}
          />
        </div>

        <div style={{ marginBottom: 24 }}>
          <span style={sectionLabelStyle}>Logistics Partner</span>
          <Space wrap size={8}>
            {PARTNER_OPTIONS.map((name) => (
              <Button
                key={name}
                size="small"
                style={chipStyle(partner.includes(name))}
                onClick={() => setPartner((prev) => toggle(prev, name))}
              >
                {name}
              </Button>
            ))}
          </Space>
        </div>
      </Drawer>
    </>
  );
}
